import React, { useState, useEffect } from "react";
import { ToastContainer, toast, Bounce } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import styles from "./sellerdiscountblock2.module.css";
import SellerDiscountBlock3 from "../SellerDiscountBlock3";
import axios from "axios";
import { createDiscount } from "../../apis/discount";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { getProductName } from "../../apis/product";
import { getDiscountsList } from '../../apis/discount';

const SellerDiscountBlock2 = ({ navigateTo }) => {
  const { t } = useTranslation();
  const [cookies, setCookie] = useCookies(["access_token", "user_info"]);
  const sellerId = cookies["user_info"].sellerId;

  // Block 1: Giảm giá đơn hàng
  const OrderDiscountBlock = ({ updateSummary }) => {
    const [method, setMethod] = useState("Mã giảm giá");
    const [discountCode, setDiscountCode] = useState("");

    const handleMethodChange = (e) => {
      setMethod(e.target.value);
      updateSummary("method", e.target.value);
    };

    const handleDiscountCodeChange = (e) => {
      setDiscountCode(e.target.value);
      updateSummary("discountCode", e.target.value);
    };

    return (
      <Card className={`discount-block ${styles.card}`}>
        <Card.Body>
          <Card.Title className={styles.cardTitle}>
            Giảm giá đơn hàng
          </Card.Title>
          <Form>
            <Form.Group controlId="formGridMethod">
              <Form.Label>Phương thức</Form.Label>
              <Form.Control
                as="select"
                value={method}
                onChange={handleMethodChange}
                className={styles.formControl}
              >
                <option>Mã giảm giá</option>
                <option>Ưu đãi giảm giá tự động</option>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="formGridDiscountCode">
              <Form.Label>
                {method === "Mã giảm giá" ? "Mã giảm giá" : "Tiêu đề"}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={
                  method === "Mã giảm giá" ? "Nhập mã giảm giá" : "Nhập tiêu đề"
                }
                value={discountCode}
                onChange={handleDiscountCodeChange}
                className={styles.formControl}
              />
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
    );
  };

  // Block 2: Giá trị giảm giá

  const DiscountValueBlock = ({ updateSummary }) => {
    const [type, setType] = useState("Phần trăm");
    const [value, setValue] = useState("");
    const [selectedProduct, setSelectedProduct] = useState("");
    const [products, setProducts] = useState([]);

    const handleTypeChange = (e) => {
      setType(e.target.value);
      updateSummary("discountType", e.target.value);
    };

    const handleValueChange = (e) => {
      setValue(e.target.value);
      updateSummary("discountValue", e.target.value);
    };

    const handleProductChange = (e) => {
      const data = {
        sellerId: sellerId,
        perPage: 1000,
        page: 1,
      };
      console.log(data.perPage);
      const result = getProductName(data, cookies["access_token"]);
      if (result.status === 200) {
        console.log(result);
      } else {
        console.log("Error: ", result);
      }
      setSelectedProduct(result.data.name);
      updateSummary("specificProducts", [e.target.value]); // Adjust this if multiple products can be selected
    };

    return (
      <Card className={styles.card}>
        <Card.Body>
          <Card.Title className={styles.cardTitle}>Giá trị giảm giá</Card.Title>
          <Form>
            <Row>
              <Form.Group as={Col} controlId="formGridType">
                <Form.Control
                  as="select"
                  value={type}
                  onChange={handleTypeChange}
                  className={styles.formControl}
                >
                  <option>Phần trăm</option>
                  <option>Tiền</option>
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col} controlId="formGridValue">
                <Form.Control
                  type="number"
                  value={value}
                  onChange={handleValueChange}
                  className={styles.formControl}
                  placeholder="Nhập thông tin"
                />
              </Form.Group>
            </Row>
            <Form.Group controlId="formGridProduct">
              <Form.Label>Áp dụng cho</Form.Label>
              <Form.Control
                as="select"
                value={selectedProduct}
                onChange={handleProductChange}
                className={styles.formControl}
              >
                <option>Chọn sản phẩm cụ thể</option>
                {products.map((result) => (
                  <option key={result.data.id} value={result.data.id}>
                    {result.data.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
    );
  };

  // Block 3: Yêu cầu mua tối thiểu
  const MinPurchaseRequirementBlock = ({ updateSummary }) => {
    const [requirement, setRequirement] = useState("");
    const [amount, setAmount] = useState();
    const [quantity, setQuantity] = useState();

    const handleRequirementChange = (value) => {
      setRequirement(value);
      if (value === "nonerequire") {
        updateSummary("purchaseRequirement", true);
      } else {
        updateSummary("purchaseRequirement", false);
      }
    };

    const handleAmountChange = (e) => {
      setAmount(e.target.value);
      updateSummary("minPurchase", e.target.value);
    };

    const handleQuantityChange = (e) => {
      setQuantity(e.target.value);
      updateSummary("minPurchase", e.target.value);
    };

    return (
      <Card className={styles.card}>
        <Card.Body>
          <Card.Title className={styles.cardTitle}>
            Yêu cầu mua tối thiểu
          </Card.Title>
          <Form>
            <Form.Group controlId="formGridRequirement">
              <Form.Check
                type="radio"
                label="Không có yêu cầu tối thiểu"
                name="requirement"
                value="nonerequire"
                checked={requirement === "nonerequire"}
                onChange={() => handleRequirementChange("nonerequire")}
              />
              <Form.Check
                type="radio"
                label="Số tiền tối thiểu (đ)"
                name="requirement"
                value="amount"
                checked={requirement === "amount"}
                onChange={() => handleRequirementChange("amount")}
              />
              <Form.Check
                type="radio"
                label="Số lượng mua tối thiểu"
                name="requirement"
                value="quantity"
                checked={requirement === "quantity"}
                onChange={() => handleRequirementChange("quantity")}
              />
            </Form.Group>
            {requirement === "amount" && (
              <Form.Group controlId="formGridAmount">
                <Form.Label>Số tiền tối thiểu</Form.Label>
                <Form.Control
                  type="number"
                  value={amount}
                  onChange={handleAmountChange}
                  className={styles.formControl}
                  placeholder="Nhập số tiền tối thiểu"
                />
              </Form.Group>
            )}
            {requirement === "quantity" && (
              <Form.Group controlId="formGridQuantity">
                <Form.Label>Số sản phẩm tối thiểu</Form.Label>
                <Form.Control
                  type="number"
                  value={quantity}
                  onChange={handleQuantityChange}
                  className={styles.formControl}
                  placeholder="Nhập số sản phẩm tối thiểu"
                />
              </Form.Group>
            )}
          </Form>
        </Card.Body>
      </Card>
    );
  };


  // Block 4: Khách hàng hợp lệ
  const EligibleCustomerBlock = ({ updateSummary }) => {
    const [eligibility, setEligibility] = useState("");

    const handleEligibilityChange = (e) => {
      setEligibility(e.target.value);
      updateSummary("customerEligibility", e.target.value);
    };

    return (
      <Card className={styles.card}>
        <Card.Body>
          <Card.Title className={styles.cardTitle}>
            Khách hàng hợp lệ
          </Card.Title>
          <Form>
            <Form.Group controlId="formGridEligibility">
              <Form.Check
                type="radio"
                label="Tất cả khách hàng"
                name="eligibility"
                value="all"
                checked={eligibility === "Tất cả khách hàng"}
                onChange={handleEligibilityChange}
              />
              <Form.Check
                type="radio"
                label="Nhóm khách hàng"
                name="eligibility"
                value="group"
                checked={eligibility === "Nhóm khách hàng"}
                onChange={handleEligibilityChange}
              />
              <Form.Check
                type="radio"
                label="Khách hàng cụ thể"
                name="eligibility"
                value="specific"
                checked={eligibility === "Khách hàng cụ thể"}
                onChange={handleEligibilityChange}
              />
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
    );
  };

  // Block 5: Số lần giảm giá tối đa
  const MaxDiscountUsesBlock = ({ updateSummary }) => {
    const [usePerCustomer, setUsePerCustomer] = useState(false);
    const [limitTotalUses, setLimitTotalUses] = useState(false);
    const [totalUses, setTotalUses] = useState("");

    const handleUsePerCustomerChange = (e) => {
      setUsePerCustomer(e.target.checked);
      updateSummary("usePerCustomer", e.target.checked);
    };

    const handleLimitTotalUsesChange = (e) => {
      setLimitTotalUses(e.target.checked);
      updateSummary("limitTotalUses", e.target.checked);
    };

    const handleTotalUsesChange = (e) => {
      setTotalUses(e.target.value);
      updateSummary("totalUses", e.target.value);
    };

    return (
      <Card className={styles.card}>
        <Card.Body>
          <Card.Title className={styles.cardTitle}>
            Số lần giảm giá tối đa
          </Card.Title>
          <Form>
            <Form.Group controlId="formGridMaxUses">
              <Form.Check
                type="checkbox"
                label="Mỗi khách hàng sử dụng một lần"
                checked={usePerCustomer}
                onChange={handleUsePerCustomerChange}
                className={styles.formControl}
              />
              <Form.Check
                type="checkbox"
                label="Giới hạn tổng số lần sử dụng"
                checked={limitTotalUses}
                onChange={handleLimitTotalUsesChange}
                className={styles.formControl}
              />
              {limitTotalUses && (
                <Form.Group controlId="formGridTotalUses">
                  <Form.Label>Số lần giới hạn</Form.Label>
                  <Form.Control
                    type="number"
                    value={totalUses}
                    onChange={handleTotalUsesChange}
                    className={styles.formControl}
                    placeholder="Nhập số lần giới hạn"
                  />
                </Form.Group>
              )}
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
    );
  };


  // Block 5.5: Kết hợp ưu đãi
  // const CombineDiscountBlock = ({ updateSummary }) => {
  //   const [selectedDiscount, setSelectedDiscount] = useState("");
  //   const [discountcode, setDiscountcode] = useState([]);

  //   const handleDiscountCodeChange = (e) => {
  //     const data = {
  //       sellerId: sellerId,
  //       perPage: 1000,
  //       page: 1,
  //     };
  //     console.log(data.perPage);
  //     const result = getDiscountList(data, cookies["access_token"]);
  //     if (result.status === 200) {
  //       console.log(result);
  //     } else {
  //       console.log("Error: ", result);
  //     }
  //     getDiscountList(result.data.name);
  //     updateSummary("specificProducts", [e.target.value]); // Adjust this if multiple products can be selected
  //   };

  //   return (
  //     <Card className={styles.card}>
  //       <Card.Body>
  //         <Card.Title className={styles.cardTitle}>Kết hợp ưu đãi</Card.Title>
  //         <Form>
  //           <Form.Group controlId="formGridProduct">
  //             <Form.Control
  //               as="select"
  //               value={selectedDiscount}
  //               onChange={handleDiscountCodeChange}
  //               className={styles.formControl}
  //             >
  //               <option>Chọn ưu đãi để kết hợp</option>
  //               {discount.map((result) => (
  //                 <option key={result.data.id} value={result.data.id}>
  //                   {result.data.name}
  //                 </option>
  //               ))}
  //             </Form.Control>
  //           </Form.Group>
  //         </Form>
  //       </Card.Body>
  //     </Card>
  //   );
  // };


  // Block 6: Ngày hoạt động
  const ActiveDaysBlock = ({ updateSummary }) => {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");

    const handleStartDateChange = (e) => {
      setStartDate(e.target.value);
      updateSummary("startDate", e.target.value);
    };

    const handleEndDateChange = (e) => {
      setEndDate(e.target.value);
      updateSummary("endDate", e.target.value);
    };

    const handleStartTimeChange = (e) => {
      setStartTime(e.target.value);
      updateSummary("startTime", e.target.value);
    };

    const handleEndTimeChange = (e) => {
      setEndTime(e.target.value);
      updateSummary("endTime", e.target.value);
    };

    return (
      <Card className={styles.card}>
        <Card.Body>
          <Card.Title className={styles.cardTitle}>Ngày hoạt động</Card.Title>
          <Form>
            <Form.Group controlId="formStartDate">
              <Form.Label>Ngày bắt đầu</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
                className={styles.formControl}
              />
              <Form.Control
                type="time"
                step="1"
                value={startTime}
                onChange={handleStartTimeChange}
                className={styles.formControl}
              />
            </Form.Group>
            <Form.Group controlId="formEndDate">
              <Form.Label>Ngày kết thúc</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
                className={styles.formControl}
              />
              <Form.Control
                type="time"
                step="1"
                value={endTime}
                onChange={handleEndTimeChange}
                className={styles.formControl}
              />
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
    );
  };

  const SummaryTable = ({ summary }) => {
    return (
      <Card className={styles.card}>
        <Card.Body>
          <Card.Title className={styles.cardTitle}>Tóm tắt</Card.Title>
          <table className="table">
            <tbody>
              <tr>
                <th>Tóm tắt</th>
              </tr>
              <tr>
                <td>{summary.discountCode || "Chưa nhập"}</td>
              </tr>
              <tr>
                <th>Phương pháp</th>
              </tr>
              <tr>
                <td>{summary.method || "Chưa chọn"}</td>
              </tr>
              <tr>
                <th>Chi tiết</th>
              </tr>
              <tr>
                <td>
                  {"Giảm giá"} :{" "}
                  {summary.discountValue
                    ? summary.discountType === "Phần trăm"
                      ? `${summary.discountValue}%`
                      : `${summary.discountValue}đ`
                    : "Chưa nhập"}
                </td>
              </tr>
              <tr>
                <td>
                  {"Mua tối thiểu"} - {`${summary.minPurchase}` || "Chưa nhập"}
                </td>
              </tr>
              <tr>
                <td>{summary.customerEligibility || "Chưa chọn"}</td>
              </tr>
              <tr>
                <td>
                  {summary.usePerCustomer
                    ? "Mỗi khách hàng sử dụng một lần"
                    : ""}
                </td>
              </tr>
              <tr>
                <td>
                  {summary.limitTotalUses
                    ? `Giới hạn tổng số lần sử dụng: ${summary.totalUses}`
                    : ""}
                </td>
              </tr>
              <tr>
                <td>
                  {"Có hiệu lực từ"} {summary.startTime || ""}{" "}
                  {summary.startDate || ""}
                </td>
                <td>
                  {"Đến"} {summary.endTime || ""} {summary.endDate || ""}
                </td>
              </tr>
            </tbody>
          </table>
        </Card.Body>
      </Card>
    );
  };

  // Main Page Component
  const DiscountManagementPage = () => {
    const [summary, setSummary] = useState({
      method: "Mã giảm giá",
      discountCode: "",
      discountType: "",
      discountValue: "",
      purchaseRequirement: "",
      minPurchase: "",
      customerEligibility: "",
      maxUses: "",
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
    });

    const updateSummary = (key, value) => {
      setSummary((prevSummary) => ({
        ...prevSummary,
        [key]: value,
      }));
    };

    const handleSave = () => {
      let discountData = {
        discountMethod: summary.method,
        title: summary.discountCode,
        discountCode: summary.discountCode,
        discountValue: summary.discountValue,
        noMinimumRequirement: summary.purchaseRequirement,
        minimumPurchaseAmount: summary.amount || 0,
        minimumPurchaseQuantity: summary.quantity || 0,
        limitPerCustomer: summary.usePerCustomer,
        // maxTotalRedemptions: summary.maxUses,
        maxTotalRedemptions: summary.totalUses || 0,
        startDate: summary.startDate,
        endDate: summary.endDate,
        startTime: summary.startTime,
        endTime: summary.endTime,
        specificProducts: ["217d0e8b-1da8-4c0f-8bfe-a20ffeea749d"],
        specificCustomerSegments: ["08dcb760-9b2d-418e-8a39-3875d6051227"],
        combinableDiscounts: ["d5867d74-7b88-4d37-ba00-cfc0c8adcce4"]
      };
      toast.promise(
        new Promise(async (resolve, reject) => {
          const result = await createDiscount(
            discountData,
            cookies["access_token"]
          );
          if (result.status === 200) resolve(result);
          else reject(result);
        }),
        {
          pending: {
            render() {
              return t("submitting");
            },
            position: "top-center",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            transition: Bounce,
          },
          success: {
            render({ result }) {
              navigateTo("block2")
              return t("seller_regis_success");
            },
          },
          error: {
            render({ result }) {
              return `${t("error_occurred")}: ${result.response?.result?.message || result.message}`;
            },
          },
        },
      );
    };

    return (
      <Container className={styles.container}>
        <Row>
          <Col md={8}>
            <Button
              variant="secondary"
              onClick={() => navigateTo("block1")}
              className={styles.button}
            >
              Quay lại
            </Button>
            <OrderDiscountBlock updateSummary={updateSummary} />
            <DiscountValueBlock updateSummary={updateSummary} />
            <MinPurchaseRequirementBlock updateSummary={updateSummary} />
            <EligibleCustomerBlock updateSummary={updateSummary} />
            <MaxDiscountUsesBlock updateSummary={updateSummary} />
            {/* <CombineDiscountBlock updateSummary={updateSummary} /> */}
            <ActiveDaysBlock updateSummary={updateSummary} />
            <Button
              variant="primary"
              onClick={handleSave}
              className={styles.button}
            >
              Lưu tất cả
            </Button>
          </Col>
        </Row>
      </Container>
    );
  };

  return <DiscountManagementPage />;
};

export default SellerDiscountBlock2;
